import React from 'react';

export const CurtainRight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 65.8" {...props}>
      <path fill="#fff" d="M4.9.8h86.3v61.1H4.9z" />
      <path
        d="M91.1 62.4H4.9c-.3 0-.5-.2-.5-.5V.8c0-.3.2-.5.5-.5h86.3c.3 0 .5.2.5.5v61.1c0 .3-.3.5-.6.5zM5.4 61.3h85.2v-60H5.4v60z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M4.9.8h86.3v61.1H4.9z" />
      <path
        d="M91.1 62.4H4.9c-.3 0-.5-.2-.5-.5V.8c0-.3.2-.5.5-.5h86.3c.3 0 .5.2.5.5v61.1c0 .3-.3.5-.6.5zM5.4 61.3h85.2v-60H5.4v60z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M8.9 4.8h78.2v53H8.9z" />
        <path d="M87.1 58.4H8.9c-.3 0-.5-.2-.5-.5v-53c0-.3.2-.5.5-.5h78.2c.3 0 .5.2.5.5v53c.1.2-.2.5-.5.5zM9.4 57.3h77.1V5.4H9.4v51.9z" />
      </g>
      <path
        d="M95.5 62.4H.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h95c.3 0 .5.2.5.5 0 .2-.2.5-.5.5z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M.5.3h95v2.4H.5z" />
        <path d="M95.8 3H.2V0h95.6v3zm-95-.6h94.4V.6H.8v1.8z" fill="#fff" />
        <g>
          <path
            fill="#233762"
            stroke="#fff"
            strokeWidth={0.618}
            strokeMiterlimit={10}
            d="M49.7 63.3V.3h42v63"
          />
          <path
            fill="#233762"
            stroke="#fff"
            strokeWidth={0.654}
            strokeMiterlimit={10}
            d="M60.2 63.3V7.4M70.7 63.3V7.4M81.2 63.3V7.4"
          />
          <path
            d="M49.7 63c2.6 0 2.6 2.5 5.2 2.5s2.6-2.5 5.2-2.5 2.6 2.5 5.2 2.5 2.6-2.5 5.2-2.5 2.6 2.5 5.2 2.5S78.3 63 81 63c2.6 0 2.6 2.5 5.3 2.5 2.6 0 2.6-2.5 5.3-2.5"
            fill="#233762"
          />
          <path
            d="M49.7 63c2.6 0 2.6 2.5 5.2 2.5s2.6-2.5 5.2-2.5 2.6 2.5 5.2 2.5 2.6-2.5 5.2-2.5 2.6 2.5 5.2 2.5S78.3 63 81 63c2.6 0 2.6 2.5 5.3 2.5 2.6 0 2.6-2.5 5.3-2.5"
            fill="none"
            stroke="#fff"
            strokeWidth={0.622}
            strokeMiterlimit={10}
          />
        </g>
      </g>
    </svg>
  );
};
